export const users = (state) => state.users
export const selectAllField = (state) => state.selectAllField
export const selectedUsers = (state) => state.selectedUsers
export const totalUsers = (state) => state.totalUsers
